import { render, staticRenderFns } from "./InboundDetail.vue?vue&type=template&id=8bea904e&scoped=true&"
import script from "./InboundDetail.vue?vue&type=script&lang=js&"
export * from "./InboundDetail.vue?vue&type=script&lang=js&"
import style1 from "./InboundDetail.vue?vue&type=style&index=1&id=8bea904e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bea904e",
  null
  
)

export default component.exports